import classes from './ChatWidget.module.scss'
import { IconPlay } from './icons'
import { ChatPromoVideo } from './types'

interface Props {
  video: ChatPromoVideo
  /** Oynatıcı panel seviyesinde açılır (modal overlay sohbet paneline göre konumlanır). */
  onPlay: (video: ChatPromoVideo) => void
  disabled?: boolean
}

/**
 * Karşılama balonunun altındaki tanıtım videosu KAPAĞI. Burada `<video>` YOKTUR: dosya ~79 MB
 * olduğu için kapak yalnız görsel/başlıktır ve video ancak kullanıcı oynat'a bastığında,
 * modaldeki oynatıcı tarafından indirilmeye başlar.
 */
export default function PromoVideoCard({ video, onPlay, disabled }: Props) {
  return (
    <button
      type='button'
      className={classes.promoVideoCard}
      onClick={() => onPlay(video)}
      disabled={disabled}
      aria-label={`${video.title} — ${video.label}`}
    >
      <span
        className={classes.promoVideoCover}
        style={video.posterUrl ? { backgroundImage: `url(${video.posterUrl})` } : undefined}
      >
        {/* Kapak görseli yoksa markalı kapak: B-Gini rozeti + oynat düğmesi. */}
        {!video.posterUrl && (
          <img className={classes.promoVideoCoverLogo} src='/images/b-gini.png' alt='' draggable={false} />
        )}
        <span className={classes.promoVideoPlayBadge} aria-hidden='true'>
          <IconPlay />
        </span>
      </span>
      <span className={classes.promoVideoMeta}>
        <span className={classes.promoVideoTitle}>{video.title}</span>
        <span className={classes.promoVideoLabel}>{video.label}</span>
      </span>
    </button>
  )
}
